import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, $state, $q, $timeout,ServiceRequestService, InsuranceSuiteMetadata, TranslateService, $filter) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.processedServiceRequests = [];
        $scope.actions = InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestOperation');
        $scope.srQuery = '';
        $scope.tableConfig = {
            paginationSize: 2000,
            statusOptions: [
                { code: 'ALL', name: 'All' },   // <-- Add ALL here as first item
                { code: 'ACTIVE', name: 'Active' }
            ].concat(
                _.filter(
                    InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestProgress').codes,
                    (status) => status.code !== 'draft'
                )
            )
        };



        $timeout(() => {
            // Set model to full option object for ACTIVE
            $scope.tableConfig.status = $scope.tableConfig.statusOptions.find(opt => opt.code === 'ACTIVE');
            console.log('Default status set to:', $scope.tableConfig.status);
            console.log('Available status options:', $scope.tableConfig.statusOptions);
        });

        $scope.serviceRequests = {};
        $scope.serviceRequestsListPromise = ServiceRequestService.getServiceRequestsForVendor().then(
            (serviceRequests) => {
                $scope.serviceRequests = serviceRequests;
                $scope.applyWatches();
            },
            (error) => {
                console.error('service request retrieval failed', error);
            }
        );
    };

    ctrl.applyWatches = () => {
        $scope.$watchGroup(['srQuery', 'tableConfig.status'], $scope.applySearchFilter);
    };

    /**
     * Filters items using full-text query.
     * @param {Array} items
     * @param {String} query
     * @returns {Array}
     */
    ctrl.filterByText = (items, query) => {
        query = query.toLowerCase();

        /**
         * Checks that string matches query.
         * @param {String} str
         * @returns {boolean}
         */
        function stringMatches(str) {
            return str.toLowerCase().indexOf(query) >= 0;
        }

        /**
         * Checks that service request matches query.
         * @param {Object} serviceRequest
         * @returns {Boolean}
         */
        function srMatches(serviceRequest) {
            const allStrings = serviceRequest.services.concat(
                $scope.getID(serviceRequest),
                serviceRequest.nextStep,
                serviceRequest.customerContact
            );
            return allStrings.some(stringMatches);
        }

        return items.filter(srMatches);
    };

    /**
     * Filters item by status.
     * @param {Array} items
     * @param {String} query
     * @returns  {Array}
     */
    ctrl.filterByStatus = (items, query) => {
        const queryCode = query ? query.code : '';
        if (queryCode === 'ALL' || !query) {
            return items;
        }
        if (queryCode === 'ACTIVE') {
            const inactiveStatuses = ['canceled', 'expired', 'declined','workcomplete'];
            return items.filter(item => !inactiveStatuses.includes(item.status));
        }
        return _.filter(items, { status: queryCode });
    };

    ctrl.applySearchFilter = () => {
        let requests = $scope.serviceRequests;
        if ($scope.tableConfig.status) {
            requests = $scope.filterByStatus(requests, $scope.tableConfig.status);
        }
        if ($scope.srQuery) {
            requests = $scope.filterByText(requests, $scope.srQuery);
        }
        $scope.processedServiceRequests = requests;
    };

    ctrl.getServicesListCommaSeparated = (serviceRequest) => {
        if (typeof serviceRequest.services === 'undefined') {
            return '';
        }
        return serviceRequest.services.join(', ');
    };

    ctrl.getID = (serviceRequest) => {
        return angular.isDefined(serviceRequest.referenceNumber) ? serviceRequest.referenceNumber : serviceRequest.claimID;
    };

    ctrl.getIcon = (requestKind) => {
        return `../styles/images/common/servicerequest/${requestKind}.png`;
    };

    ctrl.getIconTooltipMessageKey = (requestKind) => {
        switch (requestKind) {
            case 'quoteonly':
                return 'servicerequest.views.service-requests.Quote';
            case 'quoteandservice':
                return 'servicerequest.views.service-requests.Quote & Perform Service';
            case 'serviceonly':
                return 'servicerequest.views.service-requests.Perform Service';
            default:
                return '';
        }
    };

    ctrl.lookupActionNameMessage = (action, serviceRequest) => {
        if (!action) {
            return;
        }

        if (action === 'addquote') {
            if (serviceRequest.isReviseQuote) {
                return 'servicerequest.services.ServiceRequestService.action.Revise Quote';
            }
            return 'servicerequest.services.ServiceRequestService.action.Add Quote';
        }
        return ServiceRequestService.getSummaryOperationNameMessageKey($scope.actions.getCode(action));
    };

    ctrl.goToServiceRequest = (requestNumber) => {
        const state = $state.get('serviceRequestDetails');
        $state.transitionTo(state, {
            serviceRequestNumber: requestNumber
        });
    };

    ctrl.hasOperation = (summary) => {
        return angular.isDefined(summary.defaultOperation) || summary.canCancel;
    };

    ctrl.getOperation = (summary) => {
        if (angular.isDefined(summary.defaultOperation)) {
            return summary.defaultOperation;
        }
        return summary.canCancel ? ('specialistcanceled') : undefined;
    };

    ctrl.getNextStep = (serviceRequest) => {
        return serviceRequest.nextStepOwnerIsSpecialist ? serviceRequest.nextStep :
            $filter('translate')('servicerequest.views.service-requests.Wait for:') + serviceRequest.nextStep;
    };

    ctrl.performOperation = (summary) => {
        const operationListItem = $scope.getOperation(summary);

        const statesForOperation = {
            'specialistacceptedwork': 'acceptWork',
            'specialistdeclined': 'declineWork',
            'specialistcompletedwork': 'completeWork',
            'specialistcanceled': 'cancelWork',
            'addinvoice': 'addInvoice',
            'specialistresumedwork': 'resumeWork',
            'addquote': 'addOrReviseQuote',
            'closeService':'closeService'
        };

        /* Generic transition into next state. */
        const stateName = statesForOperation[operationListItem];
        if (!stateName) {
            return;
        }

        const state = $state.get(stateName);
        $scope.serviceRequestPromise = ServiceRequestService.getServiceRequestDetails(summary.serviceRequestNumber).then(
            (serviceRequest) => {
                state.data.serviceRequest = serviceRequest;
                state.data.action = operationListItem;
                $state.transitionTo(state);
            },
            (error) => {
                console.error('service request retrieval failed', error);
            }
        );
    };
    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$q','$timeout','servicerequest.ServiceRequestService', 'InsuranceSuiteMetadata', 'TranslateService', '$filter'];

export default fn;
